import { render, staticRenderFns } from "./APlataformaModal.vue?vue&type=template&id=0759c2bb"
import script from "./APlataformaModal.vue?vue&type=script&lang=js"
export * from "./APlataformaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports